<template>
  <div v-if="loader">
    <b-spinner v-if="loading" label="Loading..."></b-spinner>
  </div>
</template>
<script>

import { mapActions } from 'vuex'

export default {
  name: 'SingleTopUpPaypalConfirm',
  data () {
    return {
      loading: false
    }
  },
  mounted () {
    const urlParameters = new URLSearchParams(window.location.search)
    const token = urlParameters.get('id')
    const resourcePath = urlParameters.get('resourcePath')
    if (token !== null && resourcePath !== null) {
      this.performSingleTopUp(token)
    }
    window.addEventListener('message', this.receiveMessage, false)
    window.addEventListener('oppwaError', this.onError, false)
  },
  beforeDestroy () {
    window.removeEventListener('message', this.receiveMessage)
    window.removeEventListener('oppwaError', this.onError)
  },
  computed: {
  },
  methods: {
    ...mapActions('topUp/paypal', [
      'performSingleTopUpWithPayPal'
    ]),
    async performSingleTopUp (token, stripUrl = true) {
      this.loading = true
      await this.performSingleTopUpWithPayPal({ token })
      if (stripUrl) {
        window.history.replaceState({}, document.title, window.location.pathname)
      }
      this.loading = false
    },
    receiveMessage (event) {
      const data = event.data
      const comp = this
      if (data.method === 'asyncRedirect' && data.params) {
        const param = data.params.find(item => item.name === 'id')
        if (param && param.value) {
          comp.performSingleTopUp(param.value, false)
        }
      }
    },
    onError (error) {
      console.log(error)
    }
  },
  props: {
    loader: {
      type: Boolean,
      default: false
    }
  }
}
</script>
